// @flow
/* eslint-env browser */
/* eslint-disable */
import { dynamicId } from '../common/dynamic-id';

const AD_LEADERBOARD_ATF = 'leaderboard_atf';
const AD_LEADERBOARD_BTF = 'leaderboard_btf';
const AD_SQUARE_ATF      = 'poster';
const AD_SQUARE_BTF      = 'poster_scroll';
const AD_MOBILE_TOP      = 'mobileweb-banner_top';
const AD_MOBILE_BOTTOM   = 'mobileweb-banner_bottom';
const AD_MOBILE_SECTION  = 'mobileweb-section_front_top';

const PARTNER_DEFAULT = 'partner_arkadium';
const PARTNER_UCLICK  = 'partner_uclick';
const PARTNER_UCLICK_CW = 'partner_uclick-crossword';

const AD_ID_SQUARE = 'arkhbgpt_300x250';
const AD_ID_LEADERBOARD = 'arkhbgpt_728x90';
const AD_ID_MOBILE_TOP = 'div_blockTop_0';

const ADTYPE_DESKTOP = '';
const ADTYPE_MOBILE  = '';

const getId = (id: string, partner: string) => `${partner.split('-').join('_')}_${id}`;
const getAdUnit = (type: string, partner: string) => `/7103/usatoday/${type}/entertainment/games/${partner}`;
const getMobileAdUnit = (type: string, partner: string) => `/7103/usatoday_mobile/${type}/entertainment/games/${partner}`;
const getPartner = (href: string) => {
    if (/uclick-crossword/.test(href)) {
        return PARTNER_UCLICK_CW;
    }
    if (/(uclick-|amu-)/.test(href)) {
        return PARTNER_UCLICK;
    }
    if (/puzzles\.usatoday\.com/.test(href)) {
        return PARTNER_UCLICK;
    }
    return PARTNER_DEFAULT;
};

const slotDefinition = (id: string, type: string, count: number, isMobile = false) => {
    const partner = getPartner(document.location.href)
    return {
        id: getId(id, partner),
        count,
        unit: isMobile ? getMobileAdUnit(type, partner) : getAdUnit(type, partner),
    }
};

export default {
    DESKTOP: {
        // Home Page
        get ark_display_c_0_ad_0() { return slotDefinition(AD_ID_SQUARE, AD_SQUARE_ATF, 1); },
        get ark_display_c_0_ad_1() { return slotDefinition(AD_ID_SQUARE + '_1', AD_SQUARE_BTF, 1); },
        get ark_display_c_1_ad_0() { return slotDefinition(AD_ID_SQUARE + '_2', AD_SQUARE_BTF, 2); },
        get ark_display_c_1_ad_1() { return slotDefinition(AD_ID_SQUARE + '_3', AD_SQUARE_BTF, 3); },
        get ark_display_c_2_ad_0() { return slotDefinition(AD_ID_SQUARE + '_4', AD_SQUARE_BTF, 4); },
        get ark_display_c_2_ad_1() { return slotDefinition(AD_ID_SQUARE + '_5', AD_SQUARE_BTF, 5); },
        get ark_display_c_3_ad_0() { return slotDefinition(AD_ID_SQUARE + '_6', AD_SQUARE_BTF, 6); },
        get ark_display_c_3_ad_1() { return slotDefinition(AD_ID_SQUARE + '_7', AD_SQUARE_BTF, 7); },
        get ark_display_c_4_ad_0() { return slotDefinition(AD_ID_SQUARE + '_8', AD_SQUARE_BTF, 8); },
        get ark_display_c_4_ad_1() { return slotDefinition(AD_ID_SQUARE + '_9', AD_SQUARE_BTF, 9); },
        get ark_display_c_5_ad_0() { return slotDefinition(AD_ID_SQUARE + '_10', AD_SQUARE_BTF, 10); },
        get ark_display_c_5_ad_1() { return slotDefinition(AD_ID_SQUARE + '_11', AD_SQUARE_BTF, 11); },

        get ark_display_с_0_ad_2() { return slotDefinition(AD_ID_LEADERBOARD, AD_LEADERBOARD_BTF, 1); },
        get ark_display_с_1_ad_2() { return slotDefinition(AD_ID_LEADERBOARD + '_1', AD_LEADERBOARD_BTF, 2); },
        get ark_display_с_2_ad_2() { return slotDefinition(AD_ID_LEADERBOARD + '_2', AD_LEADERBOARD_BTF, 3); },
        get ark_display_с_3_ad_2() { return slotDefinition(AD_ID_LEADERBOARD + '_3', AD_LEADERBOARD_BTF, 4); },
        get ark_display_с_4_ad_2() { return slotDefinition(AD_ID_LEADERBOARD + '_4', AD_LEADERBOARD_BTF, 5); },
        get ark_display_с_5_ad_2() { return slotDefinition(AD_ID_LEADERBOARD + '_5', AD_LEADERBOARD_BTF, 6); },

        // Game Page
        get ark_display_t1() { return slotDefinition(AD_ID_LEADERBOARD, AD_LEADERBOARD_ATF, 1); },
        get ark_display_t2() { return slotDefinition(AD_ID_LEADERBOARD + '_1', AD_LEADERBOARD_BTF, 1); },
        get ark_display_r1() { return slotDefinition(AD_ID_SQUARE, AD_SQUARE_ATF, 1); },
        get ark_display_r2() { return slotDefinition(AD_ID_SQUARE + '_1', AD_SQUARE_BTF, 1); },
        get ark_video_fallback() { return slotDefinition(AD_ID_SQUARE, AD_SQUARE_BTF, 2); },
        get ark_display_ge1() { return slotDefinition(AD_ID_LEADERBOARD + '_1', AD_LEADERBOARD_BTF, 1); },

        // Category Page
        get ark_display_bottom() { return slotDefinition(AD_ID_LEADERBOARD, AD_LEADERBOARD_BTF, 1); },
    },

    MOBILE: {
        // Home Page
        get ark_display_с_1_ad_0() { return slotDefinition(AD_ID_SQUARE, AD_MOBILE_TOP, 1, true); },
        get ark_display_с_3_ad_0() { return slotDefinition(AD_ID_SQUARE + '_1', AD_MOBILE_BOTTOM, 1, true); },
        get ark_display_с_5_ad_0() { return slotDefinition(AD_ID_SQUARE + '_2', AD_MOBILE_BOTTOM, 2, true); },

        // Game Page
        get ark_display_m1() { return slotDefinition(AD_ID_MOBILE_TOP, AD_MOBILE_TOP, 1, true); },
        get ark_display_t1() { return slotDefinition(AD_ID_MOBILE_TOP + '_1', AD_MOBILE_BOTTOM, 1, true); },
        get ark_display_top() { return slotDefinition(AD_ID_MOBILE_TOP + '_2', AD_MOBILE_BOTTOM, 2, true); },
        get ark_display_bottom() { return slotDefinition(AD_ID_SQUARE, AD_MOBILE_BOTTOM, 3, true); },
        get ark_video_fallback() { return slotDefinition(AD_ID_SQUARE + '_1', AD_MOBILE_BOTTOM, 4, true); },
    },
};
